import weather from "../../assets/images/weather.png";
import tourism from "../../assets/images/tourism.png";
const projects = [
  {
    id: "weather-app",
    title: "Weather Application",
    image: weather,
    description:
      "A weather application built using React and Weather API.",
    technologies: ["HTML", "CSS", "JavaScript","Bootstrap" ,"Weather API"],
    github: "https://github.com/",
    live: "https://yamunanagireddy.github.io/weather-app/",
  },

  {
    id: "Toursim web Application",
    title: "Exploreease-travel-website",
    image:tourism,
    description:
      "A simple Todo application using React.",
    technologies: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/",
    live: "https://yamunanagireddy.github.io/exploreease-travel-website/",
  },
];

export default projects;